import {useMemo} from 'react';
import {useLocation} from 'react-router';
import {REDIRECT_URI_NAME} from '../consts';

const ignoredPaths = ['/', '/login', '/login/callback'];

export const useCreateRedirect = (): string | undefined => {
  const {pathname, search} = useLocation();

  return useMemo(() => {
    if (ignoredPaths.includes(pathname)) {
      return undefined;
    }

    if (pathname || search) {
      return `?${REDIRECT_URI_NAME}=${encodeURIComponent(`${pathname}${search}`)}`;
    }

    return undefined;
  }, [search, pathname]);
};
